/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// Redux
import { useSelector } from 'react-redux'

// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

function ProfileHeader() {
  const userState = useSelector(state => state.user);
  return (
    <>
      <div
        className="header pb-6 d-flex align-items-center"
      >
        <span className="mask bg-gradient-custom opacity-8" />

        <Container className="d-flex align-items-center" fluid>
          <Row className="w-100">
            <Col lg="7" md="10">
              <div className="d-flex my-4">
                <h1 className="display-2 text-white">Hello {userState.user ? userState.user.displayName : ''}</h1>
                <a
                  className="avatar avatar-xl rounded-circle ml-5 bg-primary"
                  href="#"
                  onClick={e => e.preventDefault()}
                >
                  <img alt="..." src={userState.user && userState.user.photoURL ? userState.user.photoURL : require('../../assets/img/default-profile-pic.png').default} />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ProfileHeader;
